
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artist/[pid]/releases",
      function () {
        return require("private-next-pages/artist/[pid]/releases.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artist/[pid]/releases"])
      });
    }
  